import React, { Suspense } from 'react';
import { isRunningOnClientSide } from '../../../../../utils/func.js';
import { useSelector } from 'react-redux';

const Security = React.lazy(() => import('./Security.jsx'));
import ErrorBoundary from '../../../../../components/errorBoundary/ErrorBoundary.jsx';

const SecurityAsync = ({ props }) => {
    const { localization: { content } } = useSelector(state => state);

    if (isRunningOnClientSide()) {
        return (
            <ErrorBoundary>
                <Suspense fallback={<div>{content.loading}</div>}>
                    <Security {...props} />
                </Suspense>
            </ErrorBoundary>
        );
    } else return null;
};

export default SecurityAsync;
